import React from "react";
import * as R from "ramda";
import { Col, Row, Spin, Tabs } from "antd";

import { LazyImage } from "@/components/lazyImage/lazy-image";
import {
  useRawData,
  BaseInfoCard,
} from "@/containers/Video/widgets/base-type-carousel-item-video";

const { TabPane } = Tabs;

export const replaceHttpToHttps = (url) => {
  if (url) {
    return url.replace(/^http:/, "https:");
  }
  return url;
};

export const BaseTypeCarouselItemImage = (props) => {
  const { loading, rawData } = useRawData(props);

  const image = replaceHttpToHttps(R.pathOr(
    "",
    ["aliyuninfo", "MediaBasicInfo", "InputURL"],
    rawData
  ));

  if (loading) {
    return <Spin />;
  }
  return (
    <Row
      key={JSON.stringify(rawData)}
      gutter={16}
      style={{
        maxHeight: "calc(100% - 40px)",
        padding: 20,
      }}
    >
      <Col span={16}>
        <div
          className="flex-x-center"
          style={{
            maxHeight: "80vh",
          }}
        >
          <LazyImage
            className="img-fit"
            style={{
              maxHeight: "80vh",
            }}
            src={image}
            alt={R.pathOr(
              "",
              ["aliyuninfo", "MediaBasicInfo", "Title"],
              rawData
            )}
          />
        </div>
      </Col>
      <Col span={8}>
        <Tabs defaultActiveKey="1" type="card" className="bg-white h-full">
          <TabPane tab="详情" key="1">
            <BaseInfoCard rawData={rawData} {...props} />
          </TabPane>
        </Tabs>
      </Col>
    </Row>
  );
};



// WEBPACK FOOTER //
// ./src/containers/Video/widgets/base-type-carousel-item-image.js